import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import * as am4core from '@amcharts/amcharts4/core';
import { color } from '@amcharts/amcharts4/.internal/core/utils/Color';

import { PieChart3D } from '@amcharts/amcharts4/.internal/charts/types/PieChart3D';
import { Legend } from '@amcharts/amcharts4/.internal/charts/Legend';
import { PieSeries3D } from '@amcharts/amcharts4/.internal/charts/series/PieSeries3D';

const LEGEND_DATA = {
  potentialCount: 'Potential Count',
  confirmedCount: 'Confirmed Count',
}

class DonutChart extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.chart = am4core.create("chartdiv", PieChart3D);
    this.chart.hiddenState.properties.opacity = 0;

    this.chart.legend = new Legend();
    this.chart.legend.itemContainers.template.clickable = true;
    this.chart.legend.itemContainers.template.focusable = false;
    this.chart.legend.labels.template.fill = color('#CEDBDC');
    this.chart.legend.valueLabels.template.fill = color('#CEDBDC');
    this.chart.legend.labels.template.fontSize = 14;
    this.chart.legend.labels.template.fontWeight = 'bold';
    this.chart.legend.useDefaultMarker = true;
    this.marker = this.chart.legend.markers.template.children.getIndex(0);
    this.marker.cornerRadius(12, 12, 12, 12);
    this.marker.width = 14;
    this.marker.height = 14;
    this.marker.dy = 4;
    this.marker.dx = -5;

    this.chart.legend.labels.template.adapter.add('text', (text, target) => {
      const dataLegend = target.dataItem.dataContext;
      if (!target.dataItem) return text

      return text
    });

    this.chart.innerRadius = am4core.percent(20);
    this.chart.depth = 30;

    this.createSeries();
    this.updateChartsData();

  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.datasets !== prevProps.datasets) {
      this.updateChartsData();
    }
  }

  createSeries = () => {
    this.series = this.chart.series.push(new PieSeries3D());
    this.series.dataFields.value = "v";
    this.series.dataFields.depthValue = "v";
    this.series.dataFields.category = "k";
    this.series.slices.template.cornerRadius = 5;

    this.series.hiddenState.properties.opacity = 1;
    this.series.hiddenState.properties.endAngle = -90;
    this.series.hiddenState.properties.startAngle = -90;

    this.series.ticks.template.disabled = true;
    this.series.labels.template.disabled = true;
    this.series.legendSettings.valueText = '[bold]{value}[/]';

    let filter = this.series.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#CEDBDC");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.2;

    this.series.colors.list = [
      am4core.color("#FEBC77"),
      am4core.color("#2980B9"),
      am4core.color("#FF6F91"),
      am4core.color("#845EC2"),
      am4core.color("#D65DB1"),
      am4core.color("#FF6F91"),
    ];

    let rgm = new am4core.RadialGradientModifier();
    // rgm.lightnesses.push(-0.8, -0.8, -0.5, 0, - 0.5);
    // this.series.slices.template.fillModifier = rgm;
    // this.series.slices.template.strokeModifier = rgm;
    // this.series.slices.template.strokeOpacity = 0.4;
    // this.series.slices.template.strokeWidth = 0;

    rgm.opacities = [0.5, 1, 0.5];
    rgm.offsets = [0, 1, 1];
    this.series.slices.template.fillModifier = rgm;
  }

  updateChartsData = () => {
    const { datasets } = this.props;

    if (!datasets) return null

    this.chart.data = Object.entries(datasets).map(([key, value]) => {
      return {
        v: value,
        k:  key
      }
    })

  }

  render() {
    return (
      <div style={{ width: '100%'}}>
        <div id="chartdiv" style={{ width: '100%', height: "500px" }}></div>
      </div>
    )
  }
}

DonutChart.propTypes = {
  styles: PropTypes.object,
  datasets: PropTypes.array
}

export default DonutChart
